import { render, staticRenderFns } from "./StripeReturn.vue?vue&type=template&id=1005d5f9&scoped=true&"
import script from "./StripeReturn.vue?vue&type=script&lang=js&"
export * from "./StripeReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005d5f9",
  null
  
)

export default component.exports